export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline--long-white.142d792eb07f9f25eeef8423f3d45557.svg";